import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import { formatSlaGroupLevels } from 'app/shared/modules/LoanConditionInfoTable/LoanConditionInfoTable.utils';
import PropTypes from 'prop-types';

import { slaTableConfig } from './SlaGroupInfoModal.config';
import { SlaLevelColumnId } from './SlaGroupInfoModal.constants';
import { buildSlaDurationLabel, getEligibleRowStyles } from './SlaGroupInfoModal.utils';

const SlaGroupInfoModal = ({ conditionId, loanConditionByIdSelector }) => {
  const loanCondition = useSelector(loanConditionByIdSelector(conditionId));

  const rows = useMemo(() => {
    const levels = formatSlaGroupLevels(loanCondition?.slaGroup);

    return levels.map(level => ({
      id: level.loanConditionSlaLevelId,
      [SlaLevelColumnId.TYPE]: level.type,
      [SlaLevelColumnId.SLA]: buildSlaDurationLabel({ slaDuration: level.slaDuration }),
      [SlaLevelColumnId.POTENTIAL_SIGNERS]: level.potentialSignersFullNames,
      [SlaLevelColumnId.ACTUAL_SIGNERS]: level.actualSignersFullNames,
      [SlaLevelColumnId.SLA_TYPE]: level.slaType,
      [SlaLevelColumnId.ELIGIBLE_FOR_SIGN_OFF_DATE]: level.eligibleForSignOffDate,
      _level: level,
      _deletedPotential: level.deletedPotentialSignersFullNames,
      _deletedActual: level.deletedActualSignersFullNames,
      _rowStyles: getEligibleRowStyles({ isEligibleForSignOff: level.isEligibleForSignOff }),
    }));
  }, [loanCondition]);

  return <TableCDS withNoAvailableMessage config={slaTableConfig} data={rows} />;
};

SlaGroupInfoModal.propTypes = {
  conditionId: PropTypes.string.isRequired,
  loanConditionByIdSelector: PropTypes.func.isRequired,
};

export default memo(SlaGroupInfoModal);
